var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline',_vm._g(_vm._b({staticClass:"hb-timeline-wrapper pa-0",class:{ 'hb-timeline-top-icon': _vm.attrs['align-top'] }},'v-timeline',_vm.attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }